// extracted by mini-css-extract-plugin
module.exports = {"support":"Support_support__3U1im","contacts":"Support_contacts__3BVpn"};